import { createSelector } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { InvitationTypeVisitListResponse } from '@qcs/safety-client';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { AUTOCOMPLETE_MAX_ITEMS } from '../../utils/constants';
import { CancelToken } from 'axios';
import { getFirstLastNameObj } from '../../utils/format';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { invitationVisitService } from '@api/services/services';

type State = BaseType<InvitationTypeVisitListResponse[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const optionsInvitationTypeVisitSlice = baseSlice({
  name: 'optionsInvitationTypeVisit',
  initialState,
});

export const selectOptionsInvitationTypeVisitState = (state: RootState) =>
  state.optionsInvitationTypeVisit.state;
export const selectOptionsInvitationTypeVisit = createSelector(
  (state: RootState) => state.optionsInvitationTypeVisit.data,
  (data) =>
    data.map(
      (x) =>
        ({
          id: x.supplierEmployeeId,
          name: [getFirstLastNameObj(x), x.company]
            .filter((x) => !!x)
            .join(' | '),
        } as ReferenceDto)
    )
);
export const optionsInvitationTypeVisitActions =
  optionsInvitationTypeVisitSlice.actions;

export const getOptionsInvitationTypeVisit = (search: string | undefined, cancelToken: CancelToken) =>
  (dispatch: AppDispatch) => {
    const handleGetData = async () => {
      const response = await invitationVisitService.queryInvitationTypeVisit({
        q: search,
        page: 0,
        size: AUTOCOMPLETE_MAX_ITEMS,
        sort: ['name', 'asc']
      }, { cancelToken: cancelToken })
      return { data: response.data.content ?? [] };
    };

    getItem({
      dispatch,
      actions: optionsInvitationTypeVisitActions,
      getData: handleGetData,
    });
  };
